import { render, staticRenderFns } from "./allgoodsigntodo.vue?vue&type=template&id=22a22bd0&scoped=true"
import script from "./allgoodsigntodo.vue?vue&type=script&lang=js"
export * from "./allgoodsigntodo.vue?vue&type=script&lang=js"
import style0 from "./allgoodsigntodo.vue?vue&type=style&index=0&id=22a22bd0&prod&lang=scss&scoped=true"
import style1 from "./allgoodsigntodo.vue?vue&type=style&index=1&id=22a22bd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a22bd0",
  null
  
)

export default component.exports